import { cva as e } from "class-variance-authority";
// src/design/pagination/style.ts
var t = e(["inline-flex items-center justify-center font-medium transition-colors duration-fast cursor-pointer", "disabled:opacity-50 disabled:cursor-not-allowed"], {
	variants: {
		variant: {
			default: ["rounded-md border border-border text-foreground", "hover:border-primary"],
			simple: ["rounded-md text-foreground"],
			compact: ["rounded border-0 text-muted-foreground"]
		},
		size: {
			sm: "h-6 min-w-6 px-2 rounded-sm text-xs",
			md: "h-8 min-w-8 px-3 rounded-sm text-sm",
			lg: "h-10 min-w-10 px-4 rounded-md text-sm"
		},
		active: {
			true: "",
			false: ""
		}
	},
	compoundVariants: [
		{
			variant: "default",
			active: !1,
			className: ["bg-back", "hover:bg-muted"]
		},
		{
			variant: "default",
			active: !0,
			className: ["bg-primary border-primary text-primary-foreground", "hover:bg-primary hover:border-primary"]
		},
		{
			variant: "simple",
			active: !1,
			className: ["hover:bg-muted"]
		},
		{
			variant: "simple",
			active: !0,
			className: ["border-[1.5px] border-primary text-primary", "hover:bg-muted"]
		},
		{
			variant: "compact",
			active: !1,
			className: ["hover:bg-muted"]
		},
		{
			variant: "compact",
			active: !0,
			className: ["bg-primary text-primary-foreground", "hover:bg-primary"]
		}
	],
	defaultVariants: {
		variant: "default",
		size: "md",
		active: !1
	}
}), n = e("inline-flex items-center justify-center", {
	variants: {
		variant: {
			default: "text-muted-foreground",
			simple: "text-muted-foreground",
			compact: "text-muted-foreground"
		},
		size: {
			sm: "h-6 min-w-6 px-2 rounded-sm text-xs",
			md: "h-9 min-w-9 px-3 rounded-sm text-sm",
			lg: "h-10 min-w-10 px-4 rounded-md text-sm"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "md"
	}
}), r = e("", {
	variants: { size: {
		sm: "gap-1",
		md: "gap-1.5",
		lg: "gap-2"
	} },
	defaultVariants: { size: "md" }
}), i = (e) => ({
	button: (n) => t({
		variant: e?.variant,
		size: e?.size,
		active: n?.active
	}),
	ellipsis: () => n({
		variant: e?.variant,
		size: e?.size
	}),
	gap: () => r({ size: e?.size })
});
export { i as getStyles, t as paginationButtonStyles, n as paginationEllipsisStyles, r as paginationGapStyles };

//# sourceMappingURL=style.js.map